import actions from './actions';
import { createReducer } from '../../helpers/reducer';

const initState = {
  predictions: null,
  loading: false,
  hasApplicants: false,
  total: 0,
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
    isEdit: false,
  };
}

function onLoadSuccess(state, { payload }) {
  const { defaultDistrictId, hasApplicants } = payload;

  return {
    ...state,
    defaultDistrictId,
    hasApplicants,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
